import { initialState } from "../initialState";
import * as Technician from "./technicianActions";

export const technicianReducer = (state = initialState.technicians, action) => {
    switch (action.type) {
        case Technician.REQUEST_TECHNICIANS_SUCCEEDED:
            return [...action.technicians];

        case Technician.REQUEST_TECHNICIANS_FAILED:
            return [];

        default:
            return state;
    }
};
